// extracted by mini-css-extract-plugin
module.exports = {"list":"ButtonGroup_list__1v-39","wrap":"ButtonGroup_wrap__2KBvo","item":"ButtonGroup_item__myAsH","column":"ButtonGroup_column__1RzGd"};